module.exports = __webpack_public_path__ + "d56df49a807a9fd06eb1667a84d3810e.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/github.png
 ** module id = 426
 ** module chunks = 0
 **/